import { gql } from '@apollo/client';

export const GET_BRAND_ACTIVITY = gql`
  query BrandActivity($brandId: String!, $offset: Int, $limit: Int) {
    brandActivity(brandId: $brandId, offset: $offset, limit: $limit) {
      status
      code
      error
      data {
        items {
          id
          type
          referenceId
          description
          metadata
          eventDate
          createdAt
          user {
            id
            name
            email
            profilePicture
          }
        }
        hasMore
        total
        offset
      }
    }
  }
`;

export const GET_BRAND_NOTES = gql`
  query BrandNotes($brandId: String!, $offset: Int, $limit: Int) {
    brandNotes(brandId: $brandId, offset: $offset, limit: $limit) {
      status
      code
      error
      data {
        items {
          id
          message
          createdAt
          user {
            id
            name
            email
            profilePicture
          }
        }
        hasMore
        total
        offset
      }
    }
  }
`;

export const GET_BRAND_EVENTS = gql`
  query BrandEvents($brandId: String!, $offset: Int, $limit: Int) {
    brandEvents(brandId: $brandId, offset: $offset, limit: $limit) {
      status
      code
      error
      data {
        items {
          id
          name
          type
          scheduledAt
          notes
          createdAt
          user {
            id
            name
            email
            profilePicture
          }
        }
        hasMore
        total
        offset
      }
    }
  }
`;

export const GET_BRAND_CAMPAIGNS_LIST = gql`
  query BrandCampaignsList($brandId: String!, $offset: Int, $limit: Int) {
    brandCampaigns(brandId: $brandId, offset: $offset, limit: $limit) {
      status
      code
      error
      data {
        items {
          id
          name
          createdAt
        }
        hasMore
        total
        offset
      }
    }
  }
`;
